import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";

const TypeOfWorkContext = createContext();

export default function TypeOfWorkProvider({ children }) {
  const logger = useLogger();
  const [currentTypes, setCurrentTypes] = useState([]);

  const updateTypeOfWorks = async () => {
    logger.debug("TypeOfWorkProvider.updateTypeOfWorks", `Hard-coded data`);
    const data = ["Reactive", "Maintenance", "Project", "Quoted Works"];
    setCurrentTypes(data);
    return data;
  };

  const getTypeOfWorks = () => currentTypes;

  return (
    <TypeOfWorkContext.Provider
      value={{
        getTypeOfWorks,
        updateTypeOfWorks,
      }}
    >
      {children}
    </TypeOfWorkContext.Provider>
  );
}

TypeOfWorkProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useTypeOfWork = () => useContext(TypeOfWorkContext);
